import { useQuery } from '@tanstack/react-query';
import { fetchAssetTypes } from '../services/AssetService';
export const useAssetTypes = () => {
    return useQuery({
        queryKey: ['assetTypes'],
        queryFn: fetchAssetTypes,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2
    });
};
